import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './campaign-product-status-changed.component.less'],
  templateUrl: './campaign-product-status-changed.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignProductStatusChangedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CampaignProductStatusChangedTemplateData>;
}

export type CampaignProductStatusChangedTemplateData = {
  title: string;
  p1_html: string;
  button_text: string;
  button_link: string;
  footer: string;
};

export const CampaignProductStatusChangedTemplateMocks: CampaignProductStatusChangedTemplateData[] =
  [
    {
      title: 'New status for [LinkedIn - Job Posting]',
      p1_html:
        'Your job posting on the [LinkedIn - Job posting] channel for the [Campaign Name] campaign has changed its status to: <b>[Status name]</b>. Click below for more details about the campaign.',
      button_text: 'View details',
      button_link: 'http://recruitee.com',
      footer: 'Need help? support@recruitee.com',
    },
  ];
